<template>
    <component
        :is="designType"
        :sp-class="spClass"
        :icon="icon"
        :icon-height="smallIconHeight"
        :icon-width="smallIconWidth"
        :text="text"
        :text-transform="textTransform"
        :small-text="smallText"
        :loading="loading"
        :disabled="disabled"
    ></component>
</template>

<script>

import Icon from '@/components/atoms/Icon'
import RegularButton from '@/components/forms/components/RegularButton'
import TableButton from '@/components/forms/components/TableButton'

export default {
    name: 'sp-button',
    components: {
        Icon,
        RegularButton,
        TableButton
    },
    props: {
        spClass: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false,
            default: null
        },
        iconWidth: {
            type: Number,
            required: false,
            default: 18
        },
        iconHeight: {
            type: Number,
            required: false,
            default: 18
        },
        iconColor: {
            type: String,
            required: false
        },
        smallIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        text: {
            type: String,
            required: false
        },
        textTransform: {
            type: String,
            required: false
        },
        smallText: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        designType: {
            type: String,
            required: false,
            default: 'RegularButton'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        smallIconWidth () {
            return this.smallIcon ? 12 : this.iconWidth
        },
        smallIconHeight () {
            return this.smallIcon ? 12 : this.iconHeight
        }
    }
}
</script>

<style scoped lang="scss">

</style>
